export function validarCEP(cep) {
  cep = cep.replace(/\D/g, "");

  // Deve ter 8 dígitos
  if (cep.length !== 8) return false;

  // Bloqueia sequências repetidas
  if (/^(\d)\1+$/.test(cep)) return false;

  return true;
}
